<template>
    <button @click="clicked" :type="buttonType" :disabled="processing" :class="btnClass">
        <slot v-if="!processing"/>
        <i v-else class="btn__loading-icon fa-spin"/>
        {{ buttonText }}
    </button>
</template>
<script>
export default {
    name: 'SubmitButton',
    props: {
        buttonType: {
            type: String,
            default: 'submit',
        },
        hoverable: {
            type: Boolean,
            default: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'primary',
        },
    },
    computed: {
        buttonText() {
            return this.processing ? this.$t('SUBMIT_BUTTON_PLEASE_WAIT') : '';
        },
        btnClass() {
            return this.hoverable ? `btn btn--${this.color} btn--hoverable` : `btn btn--${this.color}`;
        },
    },
    methods: {
        clicked() {
            if (!this.processing) this.$emit('click');
        },
    },
};
</script>
